module.exports = __webpack_public_path__ + "static/media/image_picture.2d430894.png";